// Form submission handling
const contactForm = document.getElementById("contactForm") as HTMLFormElement;

if (contactForm) {
	contactForm.addEventListener("submit", (e) => {
		e.preventDefault();

		const submitBtn = contactForm.querySelector(
			".submit-btn",
		) as HTMLButtonElement;
		const originalText = submitBtn.innerText;

		// Simulate loading
		submitBtn.disabled = true;
		submitBtn.innerText = "发送中...";

		// Collect data (example)
		const formData = new FormData(contactForm);
		const data = Object.fromEntries(formData.entries());

		fetch("/consult/create", {
			method: "POST",
			body: JSON.stringify(data),
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((res) => {
				if (res.statusCode !== 200) {
					const msg = Array.isArray(res.message)
						? res.message.join(",")
						: res.message;
					alert(`发送失败: ${msg || "未知错误"}`);
					submitBtn.disabled = false;
					submitBtn.innerText = originalText;
					return;
				}
				// alert('感谢您的留言，我们会尽快联系您！');
				window.location.href =
					"/result-page?status=success&title=感谢您的留言&description=我们会尽快联系您";
				// contactForm.reset();
				submitBtn.disabled = false;
				submitBtn.innerText = originalText;
			});
	});
}
